import React from "react";
import {
  Table as AntTable,
  Space,
  Avatar,
  Popconfirm,
  Input,
  Button,
} from "antd";
import { useState, useRef } from "react";
import { UserOutlined, SearchOutlined } from "@ant-design/icons";
import { useStateContext } from "../../../../../contexts/ContextProvider";
import dayjs from "dayjs";

const headerStyle = {
  color: "#525252",
};

const Table = ({ data, loading }) => {
  const { currentColor } = useStateContext();
  const [setSearchText] = useState("");
  const [setSearchedColumn] = useState("");
  const searchInput = useRef(null);
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: "block",
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Reset
          </Button>

          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            close
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? "#1677ff" : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
  });

  const columns = [
    {
      title: "ลำดับ",
      align: "center",
      width: 60,
      dataIndex: "No",
      key: "No",
      onHeaderCell: () => {
        return { style: headerStyle };
      },
    },
    {
      title: "UserName",
      align: "center",
      dataIndex: "userName",
      key: "userName",
      onHeaderCell: () => {
        return { style: headerStyle };
      },
    },
    {
      title: "ประเภทเคส",
      align: "center",
      dataIndex: "caseType",
      key: "caseType",
      onHeaderCell: () => {
        return { style: headerStyle };
      },
    },
    {
      title: "Amount",
      align: "center",
      dataIndex: "amount",
      key: "amount",
      onHeaderCell: () => {
        return { style: headerStyle };
      },
    },
    {
      title: "Date",
      align: "center",
      dataIndex: "date",
      key: "date",
      onHeaderCell: () => {
        return { style: headerStyle };
      },
      render: (date) => {
        return dayjs(date).format("DD-MM-YYYY HH:mm");
      },
    },
    {
      title: "Remark",
      align: "center",
      dataIndex: "remark",
      key: "remark",
      onHeaderCell: () => {
        return { style: headerStyle };
      },
    },
  ];

  return (
    <div className="overflow-x-auto">
      <AntTable
        loading={loading}
        className="border-1 rounded-lg border-gray-200"
        dataSource={data}
        columns={columns}
        pagination={{ pageSize: 8 }}
        rowKey={"id"}
        scroll={{ x: "max-content" }}
      />
    </div>
  );
};

export default Table;
